(function () {
  "use strict";

  const CARD_SELECTOR = ".product-card";

  function updateCardLanguage(card) {
    const quickView = card.querySelector(
      ".product-card__quick-view"
    );

    if (quickView) {
      quickView.textContent = "View Inside";
      quickView.setAttribute(
        "aria-label",
        "View product inside the vault"
      );
    }

    const saleBadge = card.querySelector(
      ".product-card__badge.badge--sale"
    );

    if (
      saleBadge &&
      !saleBadge.dataset.tfvLanguageUpdated
    ) {
      const originalText = saleBadge.textContent.trim();

      saleBadge.textContent =
        "Vault Offer · " + originalText;

      saleBadge.dataset.tfvLanguageUpdated = "true";
    }

    const soldOutBadge = card.querySelector(
      ".product-card__badge.badge--sold-out"
    );

    if (soldOutBadge) {
      soldOutBadge.textContent = "Vault Closed";
    }
  }

  function addCardStatus(card) {
    const info = card.querySelector(".product-card__info");

    if (
      !info ||
      info.querySelector(".tfv-card-status")
    ) {
      return;
    }

    const soldOut = Boolean(
      card.querySelector(".badge--sold-out")
    );

    const status = document.createElement("div");

    status.className = soldOut
      ? "tfv-card-status tfv-card-status--closed"
      : "tfv-card-status";

    status.setAttribute("aria-hidden", "true");

    const led = document.createElement("span");
    led.className = "tfv-card-status__led";

    const text = document.createElement("span");
    text.textContent = soldOut
      ? "Currently Secured"
      : "Available in the Vault";

    status.appendChild(led);
    status.appendChild(text);

    info.insertBefore(status, info.firstChild);
  }

  function prepareCards(root) {
    const scope = root || document;

    const cards = Array.from(
      scope.querySelectorAll(
        CARD_SELECTOR + ":not([data-tfv-card-ready])"
      )
    );

    if (!cards.length) return [];

    cards.forEach((card, index) => {
      card.dataset.tfvCardReady = "true";

      updateCardLanguage(card);
      addCardStatus(card);

      const delayPosition = index % 8;
      const delay = Math.min(
        delayPosition * 65,
        390
      );

      card.style.setProperty(
        "--tfv-card-delay",
        delay + "ms"
      );
    });

    return cards;
  }

  function revealCards(cards) {
    if (!cards.length) return;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (
      reducedMotion ||
      !("IntersectionObserver" in window)
    ) {
      cards.forEach((card) => {
        card.classList.add("tfv-card-visible");
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, cardObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add(
            "tfv-card-visible"
          );

          cardObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: "0px 0px -25px 0px"
      }
    );

    cards.forEach((card) => {
      observer.observe(card);
    });
  }

  function initialiseCards(root) {
    const cards = prepareCards(root);
    revealCards(cards);
  }

  function observeDynamicCards() {
    if (!("MutationObserver" in window)) return;

    let scheduled = false;

    const observer = new MutationObserver(
      (mutations) => {
        let productCardAdded = false;

        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) {
              return;
            }

            if (
              node.matches?.(CARD_SELECTOR) ||
              node.querySelector?.(CARD_SELECTOR)
            ) {
              productCardAdded = true;
            }
          });
        });

        if (!productCardAdded || scheduled) return;

        scheduled = true;

        requestAnimationFrame(() => {
          initialiseCards(document);
          scheduled = false;
        });
      }
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function startVaultCards() {
    initialiseCards(document);
    observeDynamicCards();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startVaultCards
    );
  } else {
    startVaultCards();
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initialiseCards(event.target);
    }
  );
})();